export enum ChipAppearance {
  Filled = 'filled',
  Outlined = 'outlined',
}

export enum ChipSize {
  S = 's',
  M = 'm',
  L = 'l',
}
